import React from 'react'
import { isNumber } from '@/utils/numberUtilities'

function PercentageRenderer ({ value, fractionDigits }) {
  const number = parseFloat(value)

  return isNumber(number) && <React.Fragment>{ (number * 100).toFixed(fractionDigits) }%</React.Fragment>
}

export { PercentageRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/renderers/percentageRenderer.js